import { useEffect } from "react";
import AuthService from "../api/auth-service";
import { AUTH_API_URL } from "../api/urlMetaData";
import { toast } from "react-toastify";
import { REDIRECT } from "../utils/redirectUrl";

const RedirectModal = ({ title, children, onClose }) => {
  useEffect(() => {
    const isMobile = /mobile|android|iphone|ipad/i.test(navigator.userAgent);
    const redirectURL = isMobile ? REDIRECT.pwa : REDIRECT.web;

    AuthService.get(AUTH_API_URL.TOKEN_FOR_PARTNER).then((res) => {
      const token = res.headers["x-stackintel-authorization"];

      if (!token || token === undefined) {
        toast.error("Redirection to Expense Management failed.");
        onClose(false);
        return;
      }

      window.open(
        `${redirectURL}/?xt=${token}`,
        "_blank",
        "noopener,noreferrer"
      );

      setTimeout(() => {
        onClose(false);
      }, 1300);
    });
  }, []);

  return (
    <>
      <div
        className="modal fade show d-block"
        aria-labelledby="ConfirmationModal"
        aria-hidden="false"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content shadow">
            <div className="modal-header bg-light">
              <h5
                className="modal-title mx-auto text-capitalize text-muted"
                id="ConfirmationModal"
              >
                {title ? title : "Confirm"}
              </h5>
            </div>
            <div className="modal-body p-4">{children}</div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show" onClick={onClose}></div>
    </>
  );
};

export default RedirectModal;
